import { Component, OnInit } from '@angular/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { RegistrationAdminService } from 'src/app/admin/e-services/e-booking/shared/services/registration-admin.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AgentService } from '../shared/services/agent.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-activate-agent-representative',
  templateUrl: './activate-agent-representative.component.html',
  styleUrls: ['./activate-agent-representative.component.css']
})
export class ActivateAgentRepresentativeComponent implements OnInit {

  agentId: string;

  showRequest = false;
  isErrorMessage: boolean= false;
  constructor(private globalSrv: GlobalServices, private alertService: AlertService,
    private agentSrv: AgentService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,  private route: ActivatedRoute,) {
 
      this.agentId = this.route.snapshot.params.Id;
    

    if( this.agentId){
     this.activate( this.agentId); 
    }
  }

  ngOnInit() {
  }


  activate(agentId) {
    this.agentSrv.ActivateRepresentative(agentId).subscribe(
      d => {
        if(d.Success){

          this.showRequest = true;
          this.isErrorMessage= false;
        }
        else{
          this.showRequest = true;
          this.isErrorMessage= true;
          this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + d.ErrorMessages[0]));
         
        }
      }
    )
  }


}
